import { createMuiTheme } from "@material-ui/core";
import { PrimaryColor } from "./colors";
export const theme = createMuiTheme({
    palette: { primary: { main: PrimaryColor } },
});
